
import Assert from "tbAssert";

const mReportDisplayName = new WeakMap();
const mReportStateName = new WeakMap();
const mShowReportInReportMenu = new WeakMap();

function isNotNullOrEmptyString(val) {
    if (typeof val === "string") {
        return (val.length > 0);
    }

    return false;
}

class ReportConfiguration {
    constructor({ reportDisplayName = null, reportStateName = null, showReportInMenu = true }) {
        Assert.StrictAssert(isNotNullOrEmptyString(reportDisplayName), "Assertion Failure: Report Name Must Be Non-Empty String");
        Assert.StrictAssert(isNotNullOrEmptyString(reportStateName), "Assertion Failure: Report State Name Must Be Non-Empty String");

        mReportDisplayName.set(this, reportDisplayName);
        mReportStateName.set(this, reportStateName);

        mShowReportInReportMenu.set(this, (showReportInMenu === true));
    }

    get displayName() {
        return mReportDisplayName.get(this);
    }

    get stateName() {
        return mReportStateName.get(this);
    }

    get showReportInMenu() {
        return mShowReportInReportMenu.get(this);
    }
}

export default ReportConfiguration;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/ReportConfiguration.js
// module id = a6Ac
// module chunks = 1